export default "__VITE_ASSET__185214bc__"